import { render } from "./cardsedit.vue?vue&type=template&id=05c4ae78"
import script from "./cardsedit.vue?vue&type=script&lang=js"
export * from "./cardsedit.vue?vue&type=script&lang=js"

import "./cardsedit.vue?vue&type=style&index=0&id=05c4ae78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__